module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "الفصل-الأول-الإخوة-الأعداء"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الفصل الأول")]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الإخوة الأعداء")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فتح المسلمون القدس في عهد ثاني الخلفاء الراشدين، أمير المؤمنين، عمر بن الخطاب رضي الله عنه عام ٦٣٨ ميلادية، بعد ستِّ سنوات فقط مِن وفاة رسول الله محمد صلى الله عليه وسلم (٦٣٢م).")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بدأَتِ الخلافات تقسِّم المسلمين قبل وأثناء وبعد وفاة رابع الخلفاء الراشدين علي بن أبي طالب رضي الله عنه، بصعود سهم الدولة الأموية بقيادة معاوية بن أبي سفيان وتغيير عاصمة الإسلام مِن المدينة المنورة إلى دمشق، في نفس الوقت بدأ ظهور فكر التشيُّع الذي كان يدعو إلى وجوب توريث الخلافة الإسلامية بين أولادِ وأحفادِ عليٍّ بن أبي طالب وفاطمة الزهراء بنت الرسول صلى الله عليه وسلم، وبمرور الوقت أصبح الخلاف بين السُّنة والشيعة ملحوظًا، ثمَّ اتَّخَذ موقفًا عدائيًّا.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "تفكك-العالم-الإسلامي-3"
    }
  }, [_c('h3', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تفكُّك العالَم الإسلامي:")]), _vm._v(" "), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn1",
      "id": "fnref1"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في عام ٧٥٠ ميلادية قامت ثورة دامية أدَّت إلى نهاية الدولة الأموية وبزوغ الدولة العباسية التي نقلَت عاصمة الخلافة الإسلامية إلى بغداد.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صاحب ذلك انتقال محور واهتمام الحكم مِن الشام ومصر والمغرب العربي بما فيه الأندلس إلى العراق وفارس، وأدَّى ذلك إلى استقلال مسلمي المغرب والأندلس والانفصال عن الدولة العباسية، ونتج عن ذلك ظهور الدولة الفاطمية الشيعية، ورفضهم الخضوع لحكم الخليفة العباسي، ثم قاموا بغزو مصر (المعز لدين الله الفاطمي وجوهر الصقلي) والقدس ودمشق وجزء كبير مِن الساحل الشرقي للبحر الأبيض المتوسط، وأنشؤوا عاصمتهم الجديدة: القاهرة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عند بداية تكوُّن فكرة الحملات الصليبية في أوروبا، كان العالم الإسلامي منشقًّا لقسمَين، كل قسم غير قادر على تحمُّل مسؤولية توحيد المسلمين والتصدِّي لأي هجوم خارجي وحماية القدس، ومع زيادة العداء بين السُنَّة في بغداد والشيعة في القاهرة بدأ يظهر ضعف وعدم قدرة كلٍّ مِن الخليفتَين العباسي والفاطمي على التحكم في أمور البلاد، حيث أصبح واضحًا أنَّ القوة الحقيقية وزمام الأمور تكمن في أيدي الوزير في القاهرة والسلطان في بغداد، نائبَي كلٍّ مِن الخليفتَين.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في منتصف القرن الحادي عشر الميلادي، رحَّب الخليفة العباسي بعنصر جديد إلى بلاط الخلافة، وهُم الأتراك السلاجقة.. كانوا قبائل مِن الأتراك هاجروا مِن جبال الأناضول لتعرُّضهم لموجة انخفاض كبير في درجة الحرارة استمرَّت عدَّة سنوات، فاضطُرُّوا للزحف جنوبًا، وفي طريقهم أطاحوا بفتات المذهب الشيعي في فارس، وعلى هذا الأساس قدَّموا أنفسهم للخليفة كقوَّة هدفها حماية المذهب السُّنِّي، ووعدوا بمساعدته على دحر الدولة الفاطمية.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أنعَم الخليفة على كلِّ أمير منهم بلقب سلطان، (هذا يعني أنَّ كلَّ ما يفعلونه له مساندة كاملة مِن الخليفة).")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn2",
      "id": "fnref2"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قام السلاجقة بفتح الشام وفلسطين، وأصبح لهم إمبراطورية عظمى مركزها العراق وفارس، وضمُّوا تحت سيطرتهم شعوبًا وقبائل كثيرة ذات لغات وديانات مختلفة يعيشون معًا بسلام، بالإضافة لعرب الجزيرة العربية ومَن اختلط بهم، ممَّا جعل اللغة العربية هي السائدة بين كلِّ هؤلاء.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانت هناك ديانات أخرى غير الإسلام، منها اليهودية، والمجوسية، وبالأخَصِّ المسيحية بمذاهبها المختلفة، كلُّ هؤلاء كانوا يتكلَّمون لغاتهم الأصلية (السريانية، أرمينية، قبطية ويونانية) بالإضافة للعربية، كذلك كان الفرس والأكراد يتكلَّمون ويكتبون العربية والفارسية والتركية، وبالتالي كان على عائلة صلاح الدين التكيُّف مع كلِّ هذه الشعوب واللغات والعادات المختلفة، فارسي، كردي، عربي وتركي، وانطبع هذا على أسماء عائلة صلاح الدين، فارسي للأخوَين الكبار (شاهنشاه وتركنشاه)، عربي لصلاح الدين والعادل")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn3",
      "id": "fnref3"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("(يوسف ومحمد)، وتركي (توغطيجين وبوري).")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانت القيادة السياسية قبل وصول السلاجقة تعتمد على هيمنة الحاكم الواحد حسب العادة الإسلامية الفارسية القديمة، لكنَّ السلاجقة جلبوا معهم العادات التركية الخاصة بهم، وهي أنَّ الحكم للعائلة، وبالتَّالي تقسَّم الدولة لدويلات وتوزَّع على أفراد العائلة، الكلُّ يخضع لسلطة الخليفة، لكنهم في الحقيقة مستقِلُّون، هذا النظام أدَّى إلى تقسيم وتفكُّك وتفرُّق وخلافات بين أفراد العائلة وخلافات أخرى بينهم وبين الخليفة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سادت الخلافات على توريث الحكم لكلِّ ولاية أو دويلة، وزادت الطموحات المنفردة، وأدَّى كلُّ ذلك إلى الانقسام والضعف، فحين وصل الصليبيون وجدوا هذا الانقسام في الدولة الإسلامية، فلَم يجدوا صعوبة في احتلال الشرق وإقامة دويلات في القدس واللاذقية وطرابلس ومقاطعة الرُّها (شمال سوريا وجنوب تركيا حاليًّا).")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("على سبيل المثال وليس الحصر: في عام ١١٣٦ م كانت السلطنة السلجوقية مقسَّمة بين حاكمَين: {سانجار (١١١٨ - ١١٥٧م) في الشرق وخاصةً فارس، وابن شقيقه مسعود (١١٣٤ - ١١٥٢م) في الغرب وخاصةً العراق}.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كان مسعود قد استحوَذ على الحكم بعد صراع مع أخيه، واستمرَّ في صراعات متواصلة مع عدَّة أمراء ومع الخليفة نفسه الذي اتُّهِم أكثر مِن مرة بالتآمر ضد السلاجقة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وفي عام ١١٣٥ نظَّم الخليفة حملة عسكرية ضد مسعود انتهَت بهزيمة الخليفة ووقوعه أسيرًا وسجنه، ثمَّ ما لبث مسعود أن أقال مَن كان له الحق في الخلافة بعد ذلك ليعيِّن أخًا آخَر للخليفة أكثر تفهُّمًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لَم تكن الشام أحسن حالًا مِن العراق، فكانت المدينتان الرئيستان دمشق وحلب تتنازعان على توسيع حدود رقعة الحكم، كلٌّ على حساب الأخرى.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الخلاصة أنَّ خلال ثلاثين عامًا بين (١١١٤ - ١١٤٦م) كانت نهاية الأمراء التسعة الذين حكموا حلب كالآتي: اغتيال خمسة، استسلام اثنين، استشهاد واحد في معركة حربية، ووفاة الأخير بأسباب طبيعية.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لَم تسلم مصر مِن هذا المناخ السياسي العنيف، ففي فترة حكم الخليفة الفاطمي \"الأمير\" (١١٠١ - ١١٣٠م) تمَّ اغتيال الوزير القوي \"الأفضل\" بواسطة المجموعة الشيعية الملقَّبة بالنيزاريين أو الباطنيِّين والمعروفين بــ \"الحشَّاشين\"، فقد ظهرَت تلك المجموعة في مصر نتيجة الصراعات على الخلافة الفاطمية عام ١٠٩٤، ثمَّ انتشرَت إلى فارس والشام، كان مِن الممكن استخدامهم لاغتيال الخصوم دون معرفة هويَّة القاتل، حيث إنَّها ستُنسَب للحشاشين.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اغتِيل الوزير الجديد الذي تولَّى بعد الأفضل، وتبعَه الخليفة نفسه عام ١١٣٠م، الكلُّ بواسطة الحشاشين، واستمرَّ الحال على هذا المنوال حتَّى إنَّه بين سنتي ١١٥٣و ١١٦٤م (عام دخول صلاح الدين لمصر)، تمَّ اغتيال أربعة مِن الوزراء الخمسة الذين تولَّوا الحكم تباعًا، وهرب الخامس إلى فلسطين حيث اغتاله الفرنج")]), _c('a', {
    staticClass: "footnote-ref",
    attrs: {
      "href": "#/text/#fn4",
      "id": "fnref4"
    }
  }, [_vm._v("4")]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ما سبب انتشار الاغتيالات كوسيلة للسلطة في الشرق الأوسط في بداية القرن الثاني عشر؟ ما الأحقِّيات التي كان يستند عليها كلُّ مَن كان يطالِب بالحكم؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("موقف الخليفتَين العباسي والفاطمي كان مختلفًا، حيث كان كلٌّ منهما يستند على نَسبه لرسول الله عليه الصلاة والسلام، لكن ذلك لَم يكن متاحًا للوزراء والسلاطين الحكَّام، فكان لا يمكن لأي مِن هؤلاء حتَّى الحلم بالحصول على الخلافة باغتيال الخليفة، لكن كانت هناك طرق عديدة يستطيع مِن خلالها الوزير أو السلطان أو الأمير الوصول للحكم خاصَّةً إذا كان الخليفة ضعيفًا، وذلك بقَتل أو خلع الخليفة وتعيين مكانه أي مِن أولاده أو فرد ضعيف مِن العائلة يمكن التحكُّم فيه بسهولة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حدث هذا في الخلافة الأموية، ثمَّ العباسية، حتَّى السلاجقة أنفسهم، وأدَّى تقسيم الدولة لدويلات يحكم كلًّا منها أمير أو سلطان طوال عمره، ويورث الحكم لعائلته، فكان مِن الطبيعي أن ينحاز ولاء هذا الحاكم لحماية حكمه واستقلال مقاطعته عن ولائه للخليفة، وسادت المشاحنات والتفرُّق، وضعفَتِ الأمَّة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سبب آخَر هو تكوين الجيوش الإسلامية، كان معظمهم مِن العبيد والمرتزقة، وكان حلمهم صعود السلَّم الاجتماعي، أي الوصول لرتبة وزير أو لمنصب في قصر الخليفة، كان ذلك يعتمد على قدرتهم في استخدام السلاح وبراعتهم فيه، وكانت مكافأتهم إقطاعًا (قطعة أرض يحصل منها على دخل مستمرٍّ في مقابل توفير قوة عسكرية تتناسب مع حجم هذا الدخل)، وقد أدَّى هذا النظام إلى زيادة سلطتهم المادية والإدارية والسياسية على جزءٍ كبير مِن الدولة، وتبعَ ذلك إهمالهم لبناء قاعدة لقيام حكم موَحَّد.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كان وقتهم مخصَّصًا للدفاع عن مقاطعتهم، أو الهجوم للأخذ بالثأر، أو الاستيلاء على مقاطعة مجاوِرة، وأصبح العنف قانون الدولة حتَّى خرج عن نطاق السيطرة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])])])]), _vm._v(" "), _c('div', {
    staticClass: "footnotes"
  }, [_c('hr'), _vm._v(" "), _c('ol', [_c('li', {
    staticStyle: {
      "direction": "ltr"
    },
    attrs: {
      "id": "fn1"
    }
  }, [_c('p', [_vm._v("John Man, \"SALADIN\". DA Capo Press, New York 2016. P. 6-7"), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref1"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "fn2"
    }
  }, [_c('p', [_vm._v("4- "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تاريخ سلاجقة الروم في آسيا الصغرى، محمد سهيل طقوش، دار النفائس، بيروت، لبنان، 2002م، ص 15-53")]), _vm._v("."), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref2"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "direction": "ltr"
    },
    attrs: {
      "id": "fn3"
    }
  }, [_c('p', [_vm._v("Anne- Marie Edde. \"SALADIN\". Paris 2008. Translated by Jane Marie Todd, from French to English, Harvard University Press, USA, 2014. P 15."), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref3"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "direction": "ltr"
    },
    attrs: {
      "id": "fn4"
    }
  }, [_c('p', [_vm._v("Anne- Marie Edde. \"SALADIN\". Paris 2008. Translated by Jane Marie Todd, from French to English, Harvard University Press, USA, 2014. P 1"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("8")]), _vm._v("."), _c('a', {
    staticClass: "footnote-back",
    attrs: {
      "href": "#/text/#fnref4"
    }
  }, [_vm._v("↩︎")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a10bb7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch008.vue
// module id = 84
// module chunks = 0